module.exports = __webpack_public_path__ + "static/media/Roggenrola_gaussian2.c7b214fc.png";